<template>
	<div class="row mb-10">
		<div class="mb-10 col-md-10">
			<a :href="props.grafana.url" target="_blank">
				Clique aqui para acessar a página com os dados do dashboard
			</a>
		</div>
		<div class="mb-10 col-md-2">
			<a id="collapse-header" data-bs-toggle="collapse" href="#collapse" role="button" aria-expanded="false" class=" row">
			<button class="btn btn-sm btn-secondary">
				<div class="card-title">
					Ajuda com login no dashboard
					<i class="fa-solid fa-question"></i>
				</div>
			</button>
		</a>
		</div>
		<div class="col-md-6">
			<div class="col-12">
				Email or username
			</div>
			<div class="col-12">
				<div class="input-group mb-3 col-md-6">
					<input type="text" class="form-control" :value="props.grafana.login" readonly>
					<div class="input-group-append">
						<button id="btn-login" class="btn btn-success" type="button" @click="copyAgentCodeToClipboard(props.grafana.login, 'btn-login')">
							<i class="fa-solid fa-copy fa-xl"></i>
							Copiar
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-6">
			<div class="col-12">
				Password
			</div>
			<div class="col-12">
				<div class="input-group mb-3">
					<input type="text" class="form-control" :value="props.grafana.password" readonly>
					<div class="input-group-append">
						<button id="btn-password" class="btn btn-success" type="button" @click="copyAgentCodeToClipboard(props.grafana.password, 'btn-password')">
							<i class="fa-solid fa-copy fa-xl"></i>
							Copiar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<fieldset class="collapse" id="collapse">
			<div class="row">
				<div class="col-lg-12">
					<div class="col-md-12">
						<p>1 - Click no link disponivel na página, ou no link ao lado
							<a :href="props.grafana.url" target="_blank">Link</a>
						</p>
					</div>
					<div class="col-md-12 row my-1">
						<div class="col-md-6">
							<p>2 - Digitar ou copiar no botão no campo "Email or username" aqui no site e preencher com o dado no campo "Email or username" do site do dashboard <strong></strong></p>
						</div>
						<div class="col-md-6">
							<img :src="props.grafana.img_username" alt="" style="border-radius: 5px; width: 100%">
						</div>
					</div>
					<div class="col-md-12 row my-1">
						<div class="col-md-6">
							<p>3 - Digitar ou copiar no botão no campo "Password" aqui no site e preencher com o dado no campo "Password" do site do dashboard</p>
						</div>
						<div class="col-md-6">
							<img :src="props.grafana.img_password" alt="" style="border-radius: 5px; width: 100%">
						</div>
					</div>
				</div>
			</div>
	</fieldset>
</template>

<script setup lang="ts">

const props = defineProps({
	computer_uid: { type: String, required: true },
	grafana: { type: Object, required: true },
});

function copyAgentCodeToClipboard(text_to_clipboard, btn) {
	window.navigator.clipboard.writeText(text_to_clipboard);
	$('#btn-login, #btn-password').html(`
		<i class="fa-solid fa-copy fa-xl"></i>
		Copiar
	`)
	$(`#${btn}`).html(`
		<i class="fa-solid fa-check"></i>
		Copiado
	`);
}

</script>
